// Blog articles, in English and Arabic. Newest first.
export const POSTS = [
  {
    slug: 'delivery-prices-oman-saudi',
    date: '2026-09-28',
    minutes: 4,
    tag: { en: 'Delivery', ar: 'التوصيل' },
    en: {
      title: 'How to price delivery across the Gulf',
      excerpt: 'One flat fee rarely works when you deliver from Muscat to Salalah. Here is a simple way to set prices that are fair to customers and keep you profitable.',
      body: [
        'A single delivery fee is easy, but it means customers next door pay the same as customers 1,000 km away. Either you lose money on long trips, or nearby customers feel overcharged and leave at checkout.',
        '## Start with zones you already know',
        'Group areas by how you actually deliver. For many Muscat businesses that means three groups: your own wilayat, the rest of Muscat governorate, and everywhere else in Oman through a courier. In Saudi Arabia, the UAE and the other Gulf countries, start with your city, the rest of your region or emirate, and everywhere else.',
        '## Price from your real cost',
        'Take what a trip costs you - driver time, fuel or the courier rate - and round up to a clear number. Customers trust 1.500 OMR more than 1.430 OMR.',
        '## Use free delivery as a goal, not a gift',
        'Free delivery from a minimum order (for example from 15 OMR) raises the average basket. Set the minimum a little above your current average order so customers add one more item.',
        '## Show the delivery time',
        'A short note like "Same day" or "2-3 days" next to each area answers the most common WhatsApp question before it is asked.',
        'In your dashboard, open Shipping, add the main cities of any Gulf country (Oman, Saudi Arabia, the UAE, Qatar, Kuwait or Bahrain) in one click, then adjust each price or set one price for a whole region.',
      ],
    },
    ar: {
      title: 'كيف تسعّر التوصيل في دول الخليج',
      excerpt: 'رسوم التوصيل الموحّدة نادرًا ما تنجح عندما توصل من مسقط إلى صلالة. إليك طريقة بسيطة لتحديد أسعار عادلة للعملاء ومربحة لك.',
      body: [
        'رسوم التوصيل الموحّدة سهلة، لكنها تعني أن جارك يدفع ما يدفعه عميل يبعد ألف كيلومتر. فإما أن تخسر في المشاوير البعيدة، أو يشعر العملاء القريبون بأن السعر مبالغ فيه فيتركون السلة.',
        '## ابدأ بالمناطق التي تعرفها',
        'جمّع المناطق حسب طريقة توصيلك الفعلية. كثير من الأنشطة في مسقط تكفيها ثلاث مجموعات: ولايتك، وباقي محافظة مسقط، وبقية السلطنة عبر شركة شحن. وفي السعودية والإمارات وباقي دول الخليج: مدينتك، ثم باقي منطقتك أو إمارتك، ثم بقية المناطق.',
        '## سعّر حسب تكلفتك الحقيقية',
        'احسب تكلفة المشوار عليك - وقت السائق والوقود أو سعر شركة الشحن - ثم قرّبه إلى رقم واضح. العميل يثق بسعر 1.500 ر.ع أكثر من 1.430 ر.ع.',
        '## اجعل التوصيل المجاني هدفًا لا هدية',
        'التوصيل المجاني ابتداءً من حد أدنى للطلب (مثلًا من 15 ر.ع) يرفع متوسط السلة. اجعل الحد أعلى قليلًا من متوسط طلباتك الحالي ليضيف العميل منتجًا إضافيًا.',
        '## اعرض مدة التوصيل',
        'ملاحظة قصيرة مثل «نفس اليوم» أو «2-3 أيام» بجانب كل منطقة تجيب عن أكثر سؤال يصلك على واتساب قبل أن يُطرح.',
        'من لوحة التحكم افتح «الشحن»، وأضف المدن الرئيسية في أي دولة خليجية (عُمان أو السعودية أو الإمارات أو قطر أو الكويت أو البحرين) بضغطة واحدة، ثم عدّل سعر كل مدينة أو حدّد سعرًا واحدًا لمنطقة كاملة.',
      ],
    },
  },
  {
    slug: 'qr-menu-restaurant-guide',
    date: '2026-09-15',
    minutes: 5,
    tag: { en: 'Restaurants', ar: 'المطاعم' },
    en: {
      title: 'A practical guide to QR menus for restaurants and cafés',
      excerpt: 'QR ordering can shorten waiting times and raise order values - if the menu is set up well. What to get right before you print the codes.',
      body: [
        'A QR menu is more than a PDF on a phone. When guests can order and pay from the table, staff spend less time walking back and forth and more time looking after people.',
        '## Photos sell',
        'Dishes with a clear photo are ordered more often. Use daylight, a plain background and the real portion size. You do not need a photographer - a recent phone is enough.',
        '## Keep categories short',
        'Five to eight categories are easier to scan than twenty. Put your best sellers and drinks near the top; karak and fresh juices are often the easiest extra item.',
        '## One code per table',
        'Each table gets its own QR code, so the kitchen knows exactly where an order goes. Print them on sturdy stands and keep a spare set.',
        '## Connect the kitchen',
        'Orders should appear on the kitchen screen the second they are placed. Mark them preparing and ready, and the guest sees the status on their phone.',
        'When you are ready, add your tables in the dashboard, download the QR codes and run a test order yourself before opening.',
      ],
    },
    ar: {
      title: 'دليل عملي لقوائم QR في المطاعم والمقاهي',
      excerpt: 'الطلب عبر رمز QR يختصر الانتظار ويرفع قيمة الطلب - إذا جُهّزت القائمة جيدًا. ما الذي يجب ضبطه قبل طباعة الرموز.',
      body: [
        'قائمة QR أكثر من ملف PDF على الهاتف. عندما يطلب الضيوف ويدفعون من الطاولة، يقضي الموظفون وقتًا أقل في الذهاب والإياب ووقتًا أكثر في خدمة الضيوف.',
        '## الصور تبيع',
        'الأطباق ذات الصور الواضحة تُطلب أكثر. صوّر في ضوء النهار على خلفية بسيطة وبحجم الحصة الحقيقي. لا تحتاج مصورًا محترفًا؛ يكفي هاتف حديث.',
        '## اختصر الفئات',
        'من خمس إلى ثماني فئات أسهل في التصفح من عشرين. ضع الأكثر مبيعًا والمشروبات في الأعلى؛ فالكرك والعصائر الطازجة غالبًا أسهل إضافة للطلب.',
        '## رمز لكل طاولة',
        'لكل طاولة رمز QR خاص بها، فيعرف المطبخ بالضبط إلى أين يذهب الطلب. اطبعها على حوامل متينة واحتفظ بنسخة احتياطية.',
        '## اربط المطبخ',
        'يجب أن يظهر الطلب على شاشة المطبخ لحظة إرساله. حدّده «قيد التحضير» ثم «جاهز»، فيرى الضيف الحالة على هاتفه.',
        'عندما تكون جاهزًا، أضف طاولاتك من لوحة التحكم، وحمّل رموز QR، وجرّب طلبًا بنفسك قبل الافتتاح.',
      ],
    },
  },
  {
    slug: 'whatsapp-marketing-without-getting-blocked',
    date: '2026-09-02',
    minutes: 4,
    tag: { en: 'Marketing', ar: 'التسويق' },
    en: {
      title: 'WhatsApp marketing that customers welcome',
      excerpt: 'WhatsApp is where your customers are. A few simple rules keep your messages wanted - and keep your number safe.',
      body: [
        'Across the Gulf, customers often prefer WhatsApp to email. That makes it powerful for offers, and easy to overuse.',
        '## Ask first',
        'Only message customers who agreed to receive offers, for example with a checkbox when they create an account. It is respectful, and it is the law in both countries.',
        '## Make it easy to stop',
        'Tell customers they can reply STOP at any time, and honour it straight away. Fewer, happier recipients beat a long list that reports you as spam.',
        '## Send less, but better',
        'One clear offer with a photo and a deadline works better than daily messages. Weekends, Ramadan evenings and paydays are natural moments.',
        '## Pace your sends',
        'Messages should go out one by one, a few seconds apart, rather than all at once. This looks natural and protects your number.',
        'In the dashboard, connect your WhatsApp with a QR code and send a campaign to customers who opted in - the platform paces the messages and handles STOP replies for you.',
      ],
    },
    ar: {
      title: 'تسويق عبر واتساب يرحّب به العملاء',
      excerpt: 'عملاؤك موجودون على واتساب. بضع قواعد بسيطة تجعل رسائلك مرغوبة وتحمي رقمك.',
      body: [
        'في دول الخليج يفضّل كثير من العملاء واتساب على البريد الإلكتروني، ما يجعله قويًا في العروض وسهل الإفراط في الوقت نفسه.',
        '## اطلب الإذن أولًا',
        'راسل فقط العملاء الذين وافقوا على استلام العروض، مثلًا بخانة اختيار عند إنشاء الحساب. هذا احترام للعميل، وهو أيضًا ما يفرضه القانون في البلدين.',
        '## اجعل الإيقاف سهلًا',
        'أخبر العملاء أنهم يستطيعون الرد بكلمة STOP أو «إيقاف» في أي وقت، ونفّذ ذلك فورًا. قائمة أصغر راضية أفضل من قائمة طويلة تبلّغ عنك كرسائل مزعجة.',
        '## أرسل أقل ولكن أفضل',
        'عرض واحد واضح مع صورة وموعد انتهاء أنجح من رسائل يومية. نهاية الأسبوع وليالي رمضان وأيام الرواتب أوقات طبيعية للعروض.',
        '## وزّع الإرسال',
        'يجب أن تخرج الرسائل واحدة تلو الأخرى بفاصل ثوانٍ، لا دفعة واحدة. هذا يبدو طبيعيًا ويحمي رقمك.',
        'من لوحة التحكم اربط واتساب برمز QR وأرسل حملة للعملاء الموافقين - وتتولى المنصة توزيع الرسائل ومعالجة ردود الإيقاف عنك.',
      ],
    },
  },
  {
    slug: 'first-100-online-orders',
    date: '2026-08-20',
    minutes: 3,
    tag: { en: 'Growth', ar: 'النمو' },
    en: {
      title: 'Your first 100 online orders: a simple plan',
      excerpt: 'A new website does not bring orders on its own. Five habits that get small businesses to their first hundred online orders.',
      body: [
        'Most new stores get their first orders from people who already know them. The goal is to move those conversations from chat to your website.',
        '## Put the link everywhere',
        'Instagram bio, WhatsApp Business profile, Google Maps listing, receipts and packaging. Every place a customer already looks.',
        '## Answer with the link',
        'When someone asks "how much?" on WhatsApp, reply with the product link. They see the photo, price and delivery fee and can order in one go.',
        '## Reward the first order',
        'A small welcome offer or loyalty points on the first order gives people a reason to try ordering online instead of messaging.',
        '## Watch what sells',
        'Check your reports every week. Move the best sellers to the top, and remove what nobody buys so the menu or shop stays easy to browse.',
        '## Ask for a review',
        'After a good delivery, ask happy customers to share your link with a friend. Word of mouth is still the fastest channel in the Gulf.',
      ],
    },
    ar: {
      title: 'أول 100 طلب إلكتروني: خطة بسيطة',
      excerpt: 'الموقع الجديد لا يجلب الطلبات وحده. خمس عادات توصل الأنشطة الصغيرة إلى أول مئة طلب إلكتروني.',
      body: [
        'معظم المتاجر الجديدة تحصل على أول طلباتها من أشخاص يعرفونها بالفعل. الهدف هو نقل هذه المحادثات من الدردشة إلى موقعك.',
        '## ضع الرابط في كل مكان',
        'في نبذة إنستغرام، وملف واتساب للأعمال، وخرائط Google، والإيصالات والتغليف. في كل مكان ينظر إليه العميل أصلًا.',
        '## أجب بالرابط',
        'عندما يسألك أحد على واتساب «بكم؟»، أرسل له رابط المنتج. سيرى الصورة والسعر ورسوم التوصيل ويطلب مباشرة.',
        '## كافئ الطلب الأول',
        'عرض ترحيبي صغير أو نقاط ولاء على أول طلب يمنح العملاء سببًا لتجربة الطلب الإلكتروني بدل المراسلة.',
        '## راقب ما يُباع',
        'راجع تقاريرك كل أسبوع. ضع الأكثر مبيعًا في الأعلى، واحذف ما لا يشتريه أحد حتى تبقى القائمة أو المتجر سهل التصفح.',
        '## اطلب التوصية',
        'بعد توصيل ناجح، اطلب من العملاء الراضين مشاركة رابطك مع صديق. فالكلمة الطيبة ما زالت أسرع وسيلة تسويق في الخليج.',
      ],
    },
  },
]

export const postBySlug = slug => POSTS.find(p => p.slug === slug)
